import React from 'react';
import { get, post, put, del, patch } from '../Http';
import { changePasswordGet, userNotificationsGet, userNotificationsPatch, userChangePasswordApi, userDetailsGet, orgListingGet, showNotificationGet, chatHistoryListGet, starUpdateData, followUpPostGet, customFieldLabelListsGet, alltemplateListGet, ondemandTemplateListsGet, CampaignBroadcastingGet, lastFromIdUpdateData, userInformationUpdateGet, ContactsListingGet, nonExixtsCustomerCreate, allgroupContactListsGet, getGroupAndContactListGet, clearChatHistoryGet, userInformationCreate } from '../Model/UtilityModel';


import Config from '../Config';
import * as Store from '../../storeRedux'

export const changePassword = (data) => {
    return patch(`${Config.extendedUrl}users/changepassword`, data, { "Accesstoken": "", "Authorization": "" }).then((response) => {
        return changePasswordGet(response)
    })
};

export const notifications = (data) => {
    return get(`${Config.extendedUrl}notifications/list`, data).then((response) => {
        return userNotificationsGet(response)
    });
};

export const notificationsUserId = (data, type, id = "",) => {
    if (type == "patch") {
        return patch(`${Config.extendedUrl}notifications/job_read`, data).then((response) => {
            return userNotificationsPatch(response)
        });
    }
};
export const userNewPasswordChange = (data) => {
    return patch(`${Config.extendedUrl}users/changepassword`, data, { passwordChange: true }).then((response) => {
        return userChangePasswordApi(response)
    });

};

export const user_Details = (id, data) => {
    return get(`${Config.extendedUrl}admin/users/${id}`, data).then((response) => {
        return userDetailsGet(response)
    });
};

export const orgListing = (data) => {
    return get(`${Config.extendedUrl}organisation`, data).then((response) => {
        return orgListingGet(response)
    });
};

export const showNotification = (data) => {
    return get(`${Config.extendedUrl}notification`, data).then((response) => {
        return showNotificationGet(response)
    });
};

export const chatHistoryList = async (data) => {

    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return get(`${FinalUrl}chat_history/list`, data).then((response) => {
        return chatHistoryListGet(response)
    });
};

export const starUpdate = async (id, data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return patch(`${FinalUrl}chat_history/${id}`, data).then((response) => {
        return starUpdateData(response)
    })
};

export const followUpPost = async (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return post(`${FinalUrl}followup`, data).then((response) => {
        return followUpPostGet(response)
    })
};

export const customFieldListGet = (data) => {
    return get(`api/template_constant`, data).then((response) => {
        return customFieldLabelListsGet(response)
    });
};

export const alltemplateLists = (data, type) => {
    if (type == "listForReEngage") {
        let extendedUrl = Config.extendedUrl.split('/');
        let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
        return get(`${FinalUrl}master_template/list`, data).then((response) => {
            return alltemplateListGet(response)
        });
    } else if (type == "interactive_template") {
        let extendedUrl = Config.extendedUrl.split('/');
        let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
        return get(`${FinalUrl}template`, data).then((response) => {
            return alltemplateListGet(response)
        });
    } else {
        return get(`${Config.extendedUrl}template`, data).then((response) => {
            return alltemplateListGet(response)
        });
    }
};

export const ondemandTemplateLists = (id) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return get(`${FinalUrl}master_template/list/${id}`, null).then((response) => {
        return ondemandTemplateListsGet(response)
    });
};

export const campaignBroadcastingPost = (data, type, id) => {
    if (type == "post") {
        let extendedUrl = Config.extendedUrl.split('/');
        let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
        return post(`${FinalUrl}bulk_messages`, data).then((response) => {
            return CampaignBroadcastingGet(response)
        });
    }
};

export const lastFromIdUpdate = (lastFromId, data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return patch(`${FinalUrl}chat_history/${lastFromId}`, data).then((response) => {
        return lastFromIdUpdateData(response)
    })
};


export const userInformationUpdate = (data, phoneNumber, type = 'patch') => {
    if (type == "patch") {
        let extendedUrl = Config.extendedUrl.split('/');
        let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
        return patch(`${FinalUrl}customer/${phoneNumber}`, data).then((response) => {
            return userInformationUpdateGet(response)
        })
    }
    if (type == "post") {
        let extendedUrl = Config.extendedUrl.split('/');
        let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
        return post(`${FinalUrl}customer`, data).then((response) => {
            return userInformationCreate(response)
        })
    }
};

export const ContactsList = (data, type) => {
    if (type == "get") {
        let extendedUrl = Config.extendedUrl.split('/');
        let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
        return get(`${FinalUrl}customer`, data).then((response) => {
            return ContactsListingGet(response)
        });
    }
    if (type == "post") {
        let extendedUrl = Config.extendedUrl.split('/');
        let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
        return post(`${FinalUrl}customer`, data).then((response) => {
            return nonExixtsCustomerCreate(response)
        })
    }
};

export const allgroupContactLists = (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return get(`${FinalUrl}contact_groups`, data).then((response) => {
        return allgroupContactListsGet(response)
    });
};
export const getGroupAndContactList = (data, type) => {
    if (type == "get") {
        let extendedUrl = Config.extendedUrl.split('/');
        let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
        return get(`${FinalUrl}contact_groups/mergeContactGroupCustomerList`, data).then((response) => {
            return getGroupAndContactListGet(response)
        });
    }
}
export const clearChatHistory = (data) => {
    let extendedUrl = Config.extendedUrl.split('/');
    let FinalUrl = extendedUrl[0] + "/" + Store.default.getState().LoginReducer.userCredentials.user_details.version + "/";
    return del(`${FinalUrl}customer`, data).then((response) => {
        return clearChatHistoryGet(response)
    });
};